import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';
// project imports
import config from 'config';
// import Logo from 'ui-component/Logo';
import Cookies from 'js-cookie';
import Logos from 'views/utilities/Logos';
// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <ButtonBase disableRipple component={Link} to={config.defaultPath} className='main-logo'>
        {process.env.REACT_APP_SERVER && process.env.REACT_APP_SERVER == "demo" ?  <img src={Logos?.MainLogo} alt='Main Logo'/> : <img src={Logos?.MainLogo} alt="Logo"/>}
        
    </ButtonBase>
);

export default LogoSection;
